//      
                                              
             
                     
             
              
              
                  
import { origin, negate } from './position';
import didStartAfterCritical from './did-start-after-critical';

              
                                
                            
                           
                           
   

export default ({
  displaced,
  afterCritical,
  combineWith,
  displacedBy,
}      )           => {
  const isDisplaced          = Boolean(
    displaced.visible[combineWith] || displaced.invisible[combineWith],
  );

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-combined-item-displacement.js